export enum OwnerObjective {
    NoSaleProject = 'NoSaleProject',
    WantsToSellAsap = 'WantsToSellAsap',
    WantsToSellInLessThanThreeMonths = 'WantsToSellInLessThanThreeMonths',
    WantsToSellInLessThanSixMonths = 'WantsToSellInLessThanSixMonths',
    WantsToSellInLessThanOneYear = 'WantsToSellInLessThanOneYear',
    WantsToSellInMoreThanOneYear = 'WantsToSellInMoreThanOneYear',
    StartedSelling = 'StartedSelling',
}

export const WantsToSellOwnerObjectives: OwnerObjective[] = [
    OwnerObjective.WantsToSellAsap,
    OwnerObjective.WantsToSellInLessThanThreeMonths,
    OwnerObjective.WantsToSellInLessThanSixMonths,
    OwnerObjective.WantsToSellInLessThanOneYear,
    OwnerObjective.WantsToSellInMoreThanOneYear,
    OwnerObjective.StartedSelling,
];
